import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/student'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(id) {
    return http.get(`${resource}/${id}`)
  },
  update(student, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, student, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  add(student) {
    return http.post(`${resource}`, student, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(id) {
    return http.delete(`${resource}/${id}`)
  },
}
